const applyThemeToCSS = (theme: any) => {
  if (!theme) return;
  document.documentElement.style.setProperty(
    '--primary-color',
    theme.palette.primary.main
  );
  document.documentElement.style.setProperty(
    '--secondary-color',
    theme.palette.secondary.main
  );
  document.documentElement.style.setProperty(
    '--background-color',
    theme.palette.background.default
  );
  document.documentElement.style.setProperty(
    '--background-white-color',
    theme.palette.background.paper
  );
  document.documentElement.style.setProperty(
    '--paper-color',
    theme.palette.background.paper
  );
  document.documentElement.style.setProperty(
    '--text-primary',
    theme.palette.text.primary
  );
  document.documentElement.style.setProperty(
    '--text-secondary',
    theme.palette.text.secondary
  );
  document.documentElement.style.setProperty(
    '--text-Gray',
    theme.palette.text.GrayText
  );
  document.documentElement.style.setProperty(
    '--container-max-width',
    theme.maxWidth.width
  );
  document.documentElement.style.setProperty(
    '--primaryFade',
    theme.palette?.primaryFade?.main
  );
  document.documentElement.style.setProperty(
    '--custom-background',
    theme.palette.customColor1.main
  );
  document.documentElement.style.setProperty(
    '--gray-border',
    theme?.palette?.grayBorder?.main
  );
  document.documentElement.style.setProperty(
    '--custom-Heading-font',
    theme?.customHeading?.fontFamily
  );
};

export default applyThemeToCSS;
